import { MapLayer } from "react-leaflet";
import L from "leaflet";

import "./_main";

import "./layer/L.CanvasLayer.Field";
import * as d3 from "d3v4";
import { getBBoxForBounds } from "../../helper";
window.d3 = d3;
const NO_DATA_GRID = L.VectorField.fromASCIIGrids(
  `ncols        1
	nrows        1
	xllcorner    7.195475301563
	yllcorner    51.270322489917
	cellsize     0.000012217020
	NODATA_value  -1
	 -1.0`,
  `ncols        1
	 nrows        1
	 xllcorner    7.195475301563
	 yllcorner    51.270322489917
	 cellsize     0.000012217020
	 NODATA_value  -1
	  -1.0`,
  0.001
);

class VectorFieldAnimation extends MapLayer {
  constructor(props, context) {
    super(props, context);
    window.d3 = d3;
    this.context = context;
  }

  createLeafletElement() {
    let vf = NO_DATA_GRID;
    const l = L.canvasLayer.vectorFieldAnim(vf, this.props.settings);

    //without this if statement there is no animation after a model or background change
    if (this.props.bbox) {
      this.updateLayer(this.props.bbox);
    }
    l.bbox = "NO_DATA";
    return l;
  }
  updateLeafletElement(fromProps, toProps) {
    if (JSON.stringify(toProps) !== this.currentProps) {
      if (this.leafletElement) {
        this.currentProps = JSON.stringify(toProps);
        // const bounds = this.context.map.getBounds();
        // const bbox = getBBoxForBounds(bounds);
        // console.log("update bc", this.currentProps);

        this.updateLayer(toProps.bbox);
      }
    } else {
      // console.log("no update bc", this.currentProps);
    }
  }

  updateLayer(bbox) {
    let format = "image/tiff";

    let url_u = `${this.props.service}/gdalProcessor?REQUEST=translate&SRS=EPSG:4326&BBOX=${bbox[0]},${bbox[1]},${bbox[2]},${bbox[3]}&LAYERS=docs/${this.props.layerPrefix}u84${this.props.layerPostfix}.tif&FORMAT=${format}`;
    let url_v = `${this.props.service}/gdalProcessor?REQUEST=translate&SRS=EPSG:4326&BBOX=${bbox[0]},${bbox[1]},${bbox[2]},${bbox[3]}&LAYERS=docs/${this.props.layerPrefix}v84${this.props.layerPostfix}.tif&FORMAT=${format}`;

    var urls = [url_u, url_v];

    let promises;
    if (format === "image/tiff") {
      promises = urls.map((url) => fetch(url).then((r) => r.arrayBuffer()));
    } else {
      //text
      promises = urls.map((url) => fetch(url).then((r) => r.text()));
    }
    let that = this;

    Promise.all(promises).then(function (arrays) {
      let scaleFactor = 0.001; // to m/s

      let vf;
      if (format === "image/tiff") {
        vf = L.VectorField.fromGeoTIFFs(arrays[0], arrays[1], scaleFactor);
      } else {
        //text
        vf = L.VectorField.fromASCIIGrids(arrays[0], arrays[1], scaleFactor);
      }

      that.leafletElement._updateField(vf);
    });
  }
}

export default VectorFieldAnimation;
